<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
  <div>/</div>
  <div>Facilis Origin AIXM 5.1</div>
  <div>/</div>
  <div>Property: {{ propertyName }}</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3>Property: {{ propertyName }}</h3>
  </span>
  <span class="toolbar-icon">
    <mat-icon color="warn" style="cursor: pointer" (click)="openLockDialog()"
      >lock</mat-icon
    >
    <img
      class="status-icon"
      src="assets/icons/list-status.svg"
      alt="status icon"
      [routerLink]="['/data-catalogue/business-rules']"
    />
      <mat-icon color="primary" style="cursor: pointer" (click)="save()">
      save
    </mat-icon>
  </span>
</mat-toolbar>

<mat-expansion-panel
  class="custom-panel"
  [expanded]="metadataExpanded"
  (opened)="metadataExpanded = true"
  (closed)="metadataExpanded = false"
>
  <mat-expansion-panel-header>
    <mat-panel-title><b>Metadata</b> </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="metadata-content">
    <div class="metadata-item">
      <div class="metadata-key">Identifier:</div>
      <div class="metadata-value">{{ propertyName }}</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Catalogue item type:</div>
      <div class="metadata-value">Property</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Parent group:</div>
      <div class="metadata-value">
        <a
          href="/#/data-catalogue/feature/{{ featureName }}/property-group/{{
            propertyGroupName
          }}"
        >
          {{ propertyGroupName }}
        </a>
      </div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key"><b>Display name:</b></div>
      <div class="metadata-value"></div>
    </div>

    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        placeholder=""
        [(ngModel)]="propertyName"
      />
    </mat-form-field>    </div>

    <div class="metadata-item">
      <div class="metadata-key"><b>Description:</b></div>
      <div class="metadata-value"></div>
    </div>

    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
  <div class="metadata-deatil-value full-width-input">
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            matInput
            placeholder="description"
            name="description"
            rows="4"
          ></textarea>
        </mat-form-field>
      </div>    </div>

    <div class="metadata-item">
      <div class="metadata-key">Last edited by:</div>
      <div class="metadata-value">john.doe</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Last edited on:</div>
      <div class="metadata-value">1 Feb 2025</div>
    </div>
  </div>
</mat-expansion-panel>

<!-- <div class="metadata-container" [ngClass]="{'expanded': metadataExpanded, 'collapsed': !metadataExpanded}">
    <div class="metadata-container-header">
        <h4>Metadata</h4>
        <div *ngIf="!metadataExpanded" class="expand-button" (click)="toggleMetadata()">▼</div>
        <div *ngIf="metadataExpanded" class="expand-button" (click)="toggleMetadata()">▲</div>
    </div>
    <div class="metadata-content">
        <div class="metadata-item">
            <div class="metadata-key">Identifier:</div>
            <div class="metadata-value">{{ propertyName }}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Catalogue item type:</div>
            <div class="metadata-value">Property</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Parent group:</div>
            <div class="metadata-value">
                <a href="/#/data-catalogue/feature/{{featureName}}/property-group/{{propertyGroupName}}">{{ propertyGroupName }}</a>
            </div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key"><b>Display name:</b></div>
            <div class="metadata-value"></div>
        </div>
        <div class="metadata-detailed-item">
            <div class="metadata-detail-key">English</div>
            <div class="metadata-detail-value">{{ propertyName }}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key"><b>Description:</b></div>
            <div class="metadata-value"></div>
        </div>
        <div class="metadata-detailed-item">
            <div class="metadata-detail-key">English</div>
            <div class="metadata-detail-value">description</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Last edited by:</div>
            <div class="metadata-value">john.doe</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Last edited on:</div>
            <div class="metadata-value">1 Feb 2025</div>
        </div>
    </div>
</div> -->

<div class="content-container">
  <div class="tree-container">
    <div class="additional-info">
      <div class="additional-info-item">
        <div class="additional-info-key">
          Data type:
          <a
            [routerLink]="[
              '/data-catalogue/data-type',
              'CodeDesignatedPointType'
            ]"
          >
            CodeDesignatedPointType
          </a>
        </div>
        <div class="additional-info-value">
          {{ matchingProperty?._type.toString()?.substring(5) }}
        </div>
      </div>
      <div class="additional-info-item">
        <div class="additional-info-key">Feature type reference:</div>
        <div class="additional-info-value">
          <a href="/#/data-catalogue/feature/{{ featureName }}">
            {{ featureName }}
          </a>
        </div>
      </div>
      <div class="additional-info-item">
        <div class="additional-info-key">Property group:</div>
        <a
          href="/#/data-catalogue/feature/{{ featureName }}/property-group/{{
            propertyGroupName
          }}"
        >
          {{ propertyGroupName }}
        </a>
        <div class="additional-info-value"></div>
      </div>
    </div>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-description>
          ICAO Aeronautical Information Catalog
          meta-properties</mat-panel-description
        >
      </mat-expansion-panel-header>
      <p><b>Accuracy:</b> 0.1NM</p>
      <p><b>Publication resolution (AIP):</b> 0.1NM</p>
      <p><b>Publication resolution (charts):</b> 0.1NM</p>
    </mat-expansion-panel>
  </div>
  <div class="feature-info-container">
    <div class="info-title">
      <div class="official-data">Official Data</div>
      <div class="smaller">(effective 1 FEB 2025)</div>
    </div>
    <div class="occuriencies">Occurencies: 14</div>
  </div>
</div>
